/* This example requires Tailwind CSS v2.0+ */
import { ScaleIcon, InboxIcon } from '@heroicons/react/24/outline'
import Axios from 'axios'
import { useEffect, useState } from 'react'

const paramsArr = [
  {
    "Opcion": "2",
    "FIni": "",
    "FFin": ""
  },
  {
    "Opcion": "4",
    "FIni": "",
    "FFin": ""
  }
]

export default function Tarjetas({ FIni, FFin, url, headers, setLoadingAPIS }) {

  paramsArr[0].FIni = FIni
  paramsArr[0].FFin = FFin

  const [data, setData] = useState([])
  useEffect(() => {
    const fetchArr = async () => {
      try{
        const resArr = await Promise.all(
          paramsArr.map(params => Axios({
            method: 'GET',
            url: url,
            headers: headers,
            params: params,
          }))
        )

        let dataArr = resArr.map(res => res.data)
        dataArr = dataFormatter(dataArr)
        
        setData(dataArr)
        setLoadingAPIS(curr => ({...curr, tarjetas: true}))

      }catch(err){
        console.log(err)
      }
    }
    fetchArr()
  }, [])

  return (
    <div className='p-5'>
      {/*<h3 className="text-lg font-medium leading-6 text-white">A la fecha: {data[1].date}</h3>*/}
      <dl className="pt-4 gap-5 flex flex-row flex-wrap">
        {data.map((item) => (
          <div
            key={item.id}
            className="relative grow overflow-hidden rounded-lg bg-secundarioMira px-4 pt-5 pb-2 shadow sm:px-6 sm:pt-6"
          >
            <dt>
              <h2 className="text-lg font-semibold text-white">{item.title}</h2>
              <p className="truncate mb-2 text-sm font-medium text-grisMira">{item.subtitle}</p>
              <div className="absolute rounded-md bg-secundario p-3">
                <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
              </div>
            </dt>
            <dd className="ml-16 flex items-baseline flex-wrap pb-6 sm:pb-7">
              <p className="text-2xl font-semibold text-white">{item.value}</p>
              {
                item.title === 'Cargos vencidos' ?
                  <p
                    className='ml-2 flex flex-col items-baseline text-sm font-semibold text-green-500'
                  >
                    A la fecha: {item.date}
                  </p>
                  :
                  null
              }
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

const dataFormatter = (arr) => {
  let data = [
    { id: 0, title: 'Efectivo sin cuadrar', subtitle: 'En sedes', value: '', icon: InboxIcon, date: '' },
    { id: 1, title: 'Cargos vencidos', subtitle: 'Activos del ciclo actual', value: '', icon: ScaleIcon, date: '' }
  ]

  arr.map((arr_2, index) => arr_2.map((obj) => {
    if (Object.keys(obj)[0] === 'EfectivoEnCajas') {
      data[index].value = Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(Object.values(obj)[0])
      delete data[index].date
    } else if (Object.keys(obj)[0] === 'SaldoVencido') {
      data[index].value = Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(Object.values(obj)[0])
      data[index].date = Object.values(obj)[1]
    }
  }))

  return data

}